import apiClient from './apiClient';

const base = '/mensajeria';

const listarClientes = () =>
    apiClient.get(`${base}/clientes`).then((r) => r.data);

const listarConversacionesDeCliente = (cuil) =>
    apiClient.get(`${base}/clientes/${cuil}/conversaciones`).then((r) => r.data);

const listarTramites = () =>
    apiClient.get(`${base}/tramites`).then((r) => r.data);

const listarConversaciones = (idTramite) =>
    apiClient.get(`${base}/tramites/${idTramite}/conversaciones`).then((r) => r.data);

const crearConversacion = (payload) =>
    apiClient.post(`${base}/conversaciones`, payload).then((r) => r.data);

const listarMensajes = (idConversacion, pagina = 0) =>
    apiClient.get(`${base}/conversaciones/${idConversacion}/mensajes`, { params: { pagina } }).then((r) => r.data);

const enviarMensaje = (idConversacion, payload) =>
    apiClient.post(`${base}/conversaciones/${idConversacion}/mensajes`, payload).then((r) => r.data);

const marcarLeida = (idConversacion) =>
    apiClient.patch(`${base}/conversaciones/${idConversacion}/leida`).then((r) => r.data);

const archivarConversacion = (idConversacion, valor) =>
    apiClient.patch(`${base}/conversaciones/${idConversacion}/archivada`, null, { params: { valor } }).then((r) => r.data);

const historialWhatsApp = (idTramite) =>
    apiClient.get(`${base}/tramites/${idTramite}/historial-whatsapp`).then((r) => r.data);

const mensajeriaService = {
    listarClientes,
    listarConversacionesDeCliente,
    listarTramites,
    listarConversaciones,
    crearConversacion,
    listarMensajes,
    enviarMensaje,
    marcarLeida,
    archivarConversacion,
    historialWhatsApp,
};

export default mensajeriaService;
